import BaseComponent from "../BaseComponent";
import ColorBoxInput from "components/Properties/InputComponents/ColorboxInput";
import DropDownInput from "components/Properties/InputComponents/DropDownInput";
import {NumberSliderInput, NumberColorInput} from "components/Properties/InputComponents/NumberInput";

const MaterialPropertyComponent = ({selectedObject, colorOnChange, inputOnChange, dropdownOnChange, dropdownOpened, setDropdownOpened}) => {
  const {material} = selectedObject;

  return (
    <BaseComponent title="Material Property" foldable={true}>
      <ColorBoxInput name="MeshColor" objectColor={"#" + material.color.getHexString()} colorOnChange={colorOnChange} />
      <NumberSliderInput name="Shininess" value={material.shininess} min={0} max={100} step={1} inputOnChange={inputOnChange} />
      <NumberColorInput
        name="Emissive"
        value={selectedObject.material.emissiveIntensity}
        min={1}
        max={20}
        step={1}
        inputOnChange={inputOnChange}
        objectColor={"#" + material.emissive?.getHexString()}
        colorOnChange={colorOnChange}
      />
      <DropDownInput
        name="Blending"
        array={["Normal", "Additive", "Subtractive", "Multiply"]}
        dropdownOnChange={dropdownOnChange}
        value={material.blending - 1}
        selectedObject={selectedObject}
        dropdownOpened={dropdownOpened}
        setDropdownOpened={setDropdownOpened}
      />
      <NumberSliderInput name="Opacity" value={material.opacity} min={0} max={1} step={0.01} inputOnChange={inputOnChange} />
    </BaseComponent>
  );
};

export default MaterialPropertyComponent;
